export const RESET = 'RESET'

export const SET_IS_LOADING = 'SET_IS_LOADING'
export const SET_IS_LOADED = 'SET_IS_LOADED'

export const SET_CARD_SLOT = 'SET_CARD_SLOT'
export const SET_ERROR = 'SET_ERROR'
export const SET_COUPONS = 'SET_COUPONS'
